
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'RightWrongBar',
  props: {
    right: Number,
    total: Number,
  },
  methods: {}
});
